export default __webpack_public_path__ + "static/media/avatar1.678f7d63.jpeg";